import { ErrorOutline } from '@mui/icons-material';
import { chatRequestFailureMessage } from '../utils/chatRequestFailure';

const ChatRequestFailure = ({ error, onEditRequest, disabled = false }) => (
    <div className='chatV2Bubble chatV2StatusRow chatV2StatusRowFailed'>
        <span className='chatV2StatusIcon chatV2StatusIconFailed' aria-hidden='true'>
            <ErrorOutline style={{ fontSize: '18px' }} />
        </span>
        <div className='chatV2StatusContent'>
            <p className='chatV2StatusText' role='alert' aria-atomic='true'>
                {chatRequestFailureMessage(error)}
            </p>
            {onEditRequest && (
                <button
                    type='button'
                    className='homeUtilityButton chatV2FailureAction'
                    onClick={onEditRequest}
                    disabled={disabled}
                >
                    Edit request
                </button>
            )}
        </div>
    </div>
);

export default ChatRequestFailure;
